<template>
    <!-- Page header -->
    <div>
        <div class="page-header page-header-light">
            <div class="page-header-content header-elements-md-inline">
                <div class="page-title d-flex">
                    <h4><span class="font-weight-semibold">Domains</span> 
                    <button class="btn btn-primary" @click="adding = true">Add</button>
                    <button class="btn btn-primary" @click="addingMailgun = true">Add Mailgun domain</button>
                    <button class="btn btn-primary" @click="addingAws = true">Add AWS domain</button>
                    </h4>
                    <a href="#" class="header-elements-toggle text-default d-md-none"><i class="icon-more"></i></a>
                </div>
            </div>
        </div>
        <!-- /page header -->
        <!-- Content area -->
        <div class="content">
            <div class="card">
                <div class="table-responsive" :class="{'loading-mask': loading}">
                    <button @click="load" class="btn btn-primary pull-right" style="margin: 10px">Refresh domain list</button>
                    <button :disabled="page >= pages" @click="offset = (pages-1)*limit; load()" class="btn btn-primary pull-right" style="margin: 10px">Last page >></button>
                    <button :disabled="page >= pages" @click="nextPage" class="btn btn-primary pull-right" style="margin: 10px">Next page >></button>

                    <button :disabled="true" class="btn btn-primary pull-right" style="margin: 10px">Page: {{(offset/limit)+1}} / {{pages}}</button>
                    <button :disabled="offset <= 0" @click="prevPage" class="btn btn-primary pull-right" style="margin: 10px"><< Previous page</button>
                    
                    <button :disabled="offset <= 0" @click="offset = 0; load()" class="btn btn-primary pull-right" style="margin: 10px"><< First page</button>
                    
                    <table class="table table-striped table-xs" style="min-height: 100px">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Domain</th>
                                <th>Subdomains</th>
                                <th>Mailer account</th>
                                <th>Godaddy account</th>
                                <th>Status</th>
                                <th>Created at</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="r,k in rows">
                                <td style="width:10px">{{k+1}}</td>
                                <td>{{r.domain}}</td>
                                <td v-tooltip="subdomainsTooltip(r)">{{subdomains(r)}}</td>
                                <td><span class="badge" :class="{'bg-slate': r.sendgrid == 'missing', 'bg-blue': r.sendgrid !== 'missing'}">{{r.mailer_provider+": "+r.mailer}}</span></td>
                                <td><span class="badge" :class="{'bg-slate': r.godaddy == 'missing', 'bg-blue': r.godaddy !== 'missing'}">{{r.godaddy}}</span></td>
                                <td>
                                    <domain-status v-tooltip="subdomainsTooltip2(r)" :value="r" />
                                </td>
                                <td>{{r.created_at|formatDate}}</td>
                                <td>
                                    <template v-if="r.mailer_provider === 'aws'">
                                        <button class="btn btn-primary" :disabled="!(r.subdomains_status == 'new')" @click="authorize($event, r._id)">Setup domain in AWS</button>
                                        <button class="btn btn-primary" :disabled="!(r.subdomains_status == 'pending')" @click="addingAwsId = r._id">Check CNAME records</button>
                                        <button class="btn btn-primary" :disabled="!(r.subdomains_status == 'pending')" @click="validate($event, r._id)">Check domain registration status</button>
                                        <button class="btn btn-danger" @click="remove($event, r._id)">Remove domain</button>
                                    </template>
                                    <template v-if="r.mailer_provider === 'mailgun'">
                                        <button @click="authorize($event, r._id)" class="btn btn-primary" :disabled="r.subdomains_status !== 'new'" v-tooltip.left="'Adds domain and subdomain to email provider and DNS records to domain provider'">
                                            Authorize
                                        </button>
                                        <button @click="validate($event, r._id)" class="btn btn-primary" :disabled="['new', 'confirmed'].includes(r.subdomains_status)" v-tooltip.left="'Validates correctness of DNS records at domain provider with email provider'">
                                            Validate authentication
                                        </button>
                                    </template>
                                    <template v-else-if="r.mailer !== 'missing' && r.godaddy !== 'missing'">
                                        <button @click="authorize($event, r._id)" class="btn btn-primary" :disabled="r.all_subdomains_ready" v-tooltip.left="'Adds domain and subdomain to email provider and DNS records to domain provider'">
                                            Authorize
                                        </button>
                                        <button @click="authorize($event, r._id)" class="btn btn-danger" v-if="r.all_subdomains_ready" v-tooltip.left="'Adds domain and subdomain to email provider and DNS records to domain provider'">
                                            Authorize again
                                        </button>
                                        <button @click="validate($event, r._id)" class="btn btn-primary" :disabled="!r.all_subdomains_ready || r.all_subdomains_validated" v-tooltip.left="'Validates correctness of DNS records at domain provider with email provider'">
                                            Validate authentication
                                        </button>
                                        <button @click="deregisterSendgrid($event, r._id)" class="btn btn-danger">
                                            Deregister Sendgrid
                                        </button>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- /content area -->
        <domain v-if="adding" @close="adding = false" @reload="load()" />
        <domain-aws v-if="addingAws" @close="addingAws = false" :id="addingAwsId"  @reload="load()" />
        <domain-mailgun v-if="addingMailgun" @close="addingMailgun = false" :id="addingMailgunId"  @reload="load()" />
        <!-- /content area -->
    </div>
</template>
<script>
import moment from 'moment'
import EventBus from '@/event_bus'
import Domain from './modal/Domain.vue'
import DomainAws from './modal/DomainAws.vue'
import DomainMailgun from './modal/DomainMailgun.vue'
import Template from './Template.vue'
export default {
    components: { Domain, DomainAws, DomainMailgun, Template },
    data() {
        return {
            rows: [],
            loading: true,
            adding: false,
            addingAws: false,
            addingAwsId: null,
            addingMailgun: false,
            addingMailgunId: false,
            limit: 25,
            offset: 0,
            count: 0
        }
    },
    watch: {

    },
    computed: {
        pages(){
            return Math.ceil(this.count / this.limit)
        },
        page(){
            return (this.offset / this.limit)+1
        },
    },
    methods: {
        prevPage(){
            this.offset -= 25
            this.load()
        },
        nextPage(){
            this.offset += 25
            this.load()

        },
        remove(_, domainId){
            this.$confirm().then(()=>{
                this.loading = true
                this.$api.deleteReq('domain/remove/' + domainId).then(res => {
                    this.$notify.addSuccess("Domain removed")
                    this.loading = false
                    this.load()
                })
            })
        },
        deregisterSendgrid(_, domainId){
            this.$confirm().then(()=>{
                this.loading = true
                this.$api.postReq('deregister/sendgrid/' + domainId).then(res => {
                    this.$notify.addSuccess("Domain deregistered")
                    this.loading = false
                    this.load()
                })
            })
        },
        authorize(_, domainId) {
            this.loading = true
            this.$api.postReq('domain/authorize/' + domainId).then(res => {
                this.$notify.addSuccess("Domain authorized")
                this.loading = false
                this.load()
            }).catch(res => {
                this.$notify.addError("Domain not authorized")
                this.loading = false
                this.load()
            })
        },
        validate(_, domainId) {
            this.loading = true
            this.$api.postReq('domain/validate/' + domainId).then(res => {
                this.loading = false
                this.load()
            })
        },
        subdomains(domain) {
            if(domain.subdomains.length === 1 && domain.subdomains[0].subdomain === ''){
                return '-'
            }
            return domain.subdomains.map(sd => sd.subdomain || domain.domain).join(', ')
        },
        subdomainsTooltip(domain) {
            return domain.subdomains.map(sd => {
                return sd.subdomain + ': ' + sd.sendgird_mail_cname
            }).join(' | ')
        },
        subdomainsTooltip2(domain) {
            return domain.subdomains.map(sd => {

                if (!sd.sendgrid_validated) {
                    return sd.subdomain + ': ' + sd.sendgrid_domain_id
                }

                return sd.subdomain + ': ' + JSON.stringify(sd.sendgrid_validation_result)
            }).join(' | ')
        },
        load(showloader, changePage, refreshProfile) {
            this.$api.getReq(`domain?limit=${this.limit}&offset=${this.offset}`).then(res => {
                this.rows = res.body.data
                this.count = res.body.count
                this.loading = false
            })
        }
    },
    destroyed() {},
    mounted() {
        this.load()
    }
}
</script>
<style>
.avsquare {
    width: 7px;
    height: 100%;
    float: left;
    cursor: pointer;
    border-left: 1px solid rgba(0, 0, 0, .1);
}

.avsquare:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.avsquare:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

tbody .btn {
    padding: 3px 11px;
}
</style>


// WEBPACK FOOTER //
// src/components/Domains.vue